import axios from "axios";
import { API_URL } from "@/config/env";

export const getCategories = async () => {
  console.log("API Categorias ");
  try {
    const response = await axios.get(`${API_URL}/api/categories/list`);
    return {
      drinks: response.data.dataDrinks || [],
      kitchen: response.data.dataKitchen || [],
    };
  } catch (error) {
    console.error("Error fetching categories:", error);
    throw error;
  }
};
